import { render, staticRenderFns } from "./PythonClassView.vue?vue&type=template&id=0b4b7aae&scoped=true&"
import script from "./PythonClassView.vue?vue&type=script&lang=js&"
export * from "./PythonClassView.vue?vue&type=script&lang=js&"
import style0 from "./PythonClassView.vue?vue&type=style&index=0&id=0b4b7aae&prod&lang=scss&scoped=true&"
import style1 from "./PythonClassView.vue?vue&type=style&index=1&id=0b4b7aae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b7aae",
  null
  
)

export default component.exports